module.exports = __webpack_public_path__ + "img/air.c6082cac.png";